import { Injectable } from '@angular/core';
import { CachedCRUDService } from '../types/cached-c-r-u-d.service';
import {
  OfficeLight,
} from '@sisem/sisem-resources-types';
import { HttpClient, HttpParams } from '@angular/common/http';
import { lastValueFrom } from 'rxjs';
import { ServerResponse } from '../types/http.interfaces';
import { environment } from '../../../environments/environment';
import { ProviderTypeService } from './administration/provider/provider.type.service';

@Injectable({
  providedIn: 'root',
})
export class IpsLightService extends CachedCRUDService<
  OfficeLight,
  never,
  never
> {

  constructor(
    private http: HttpClient,
    private providerTypeService: ProviderTypeService
  ) {
    super();
    this.options.cacheExpiration = 1000 * 60 * 60; // refresh every hour
  }

  public override async _fetchNewData(): Promise<OfficeLight[]> {
    let params = new HttpParams();
    params = params.append('fetchContactData', true);
    const res = await lastValueFrom(
      this.http.get<ServerResponse<OfficeLight[]>>(`${environment.api}/resources-ms/api/v1/offices/light`, {
        params,
      })
    );
    const providerTypes = await this.providerTypeService.getAll();
    const IPSTypeId = providerTypes.find((type) => type.title === 'IPS')?.id;
    return res.data.filter(
      (office) => office.providerTypeId === IPSTypeId && office.primaryOffice === false
    );
  }
}